var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02041 16.7035C1.13818 16.7048 1.25494 16.6835 1.3632 16.6411C1.47145 16.5987 1.5688 16.536 1.64898 16.457L9.73061 9.06419C10.0898 8.73562 10.0898 8.22633 9.73061 7.89776L1.64898 0.521331C1.28979 0.192759 0.73306 0.192759 0.373877 0.521331C0.0146923 0.849902 0.0146923 1.35919 0.373877 1.68776L7.82694 8.48919L0.373877 15.307C0.0146923 15.6356 0.0146923 16.1449 0.373877 16.4735C0.553468 16.6378 0.786938 16.7199 1.00245 16.7199L1.02041 16.7035Z",
    fill: "#688AC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.a04dff63c4d1aef18ae6b798f59ddab3.svg";
export { ForwardRef as ReactComponent };